(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(["exports", "babel-runtime/core-js/object/keys", "lodash/get", "lodash/set", "lodash/isString", "lodash/isNumber", "lodash/isArray"], factory);
    } else if (typeof exports !== "undefined") {
        factory(exports, require("babel-runtime/core-js/object/keys"), require("lodash/get"), require("lodash/set"), require("lodash/isString"), require("lodash/isNumber"), require("lodash/isArray"));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod.exports, global.keys, global.get, global.set, global.isString, global.isNumber, global.isArray);
        global.mergeAppStylesWithTheme = mod.exports;
    }
})(this, function (exports, _keys, _get, _set, _isString, _isNumber, _isArray) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.mergeAppStylesWithTheme = undefined;

    var _keys2 = _interopRequireDefault(_keys);

    var _get2 = _interopRequireDefault(_get);

    var _set2 = _interopRequireDefault(_set);

    var _isString2 = _interopRequireDefault(_isString);

    var _isNumber2 = _interopRequireDefault(_isNumber);

    var _isArray2 = _interopRequireDefault(_isArray);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var mergeAppStylesWithTheme = exports.mergeAppStylesWithTheme = function mergeAppStylesWithTheme() {
        var applicationStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        (0, _keys2.default)(applicationStyles).map(function (key) {
            // Get the value
            var value = (0, _get2.default)(applicationStyles, key, "");

            // If the value is a string with length, or an array with length, or a number we want to set the value
            // Empty strings and arrays will not be set.
            if ((0, _isString2.default)(value) && value.length > 0 || (0, _isArray2.default)(value) && value.length > 0 || (0, _isNumber2.default)(value)) {
                // Strings including a pipe character are converted to an array of values delimited by '|'.
                // Arrays of values are used for responsive styles when supplied to a component style prop, but we may not know ahead of time which component theme values we want to be responsive.
                // Using this method we can set responsive styles without having to redefine an application template style as an array.
                if ((0, _isString2.default)(value) && value.includes("|")) {
                    value = value.split("|").map(function (val) {
                        return val.trim();
                    });
                }

                // Application style keys can be in the form of "Login.bgColor, colors.primary etc", so we update the theme object using the key as the object path.
                (0, _set2.default)(theme, key, value);
            }
        });

        return theme;
    };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-portal-components/build/utils/mergeAppStylesWithTheme.js
// module id = 1335
// module chunks = 1